module.exports = __webpack_public_path__ + "static/media/basic-icon@3x.86583fec.png";